import React, { memo } from 'react';
import { useDispatch } from 'react-redux';
import { fhwSliceActions } from '../../../store/modules/fhw/reducer';
import { uiSliceActions } from '../../../store/modules/ui/reducer';
import HydratedTwigHtmlString from 'global/react/components/HydratedTwigHtmlString';
import IconRenderer from 'global/react-mui/atoms/IconRenderer';
import Button from 'global/react-mui/atoms/Button';
import { colors } from 'global/react-mui/theme/colors';

const PartnerProfileModalContent: React.FC<{
	buttonClassName: string;
	gobackbuttonText: string;
	data: any;
}> = ({ buttonClassName, gobackbuttonText, data }) => {
	const dispatch = useDispatch();
	const closeIndividualProfileModal = () => {
		dispatch(fhwSliceActions.setSelectedPartner());
		dispatch(uiSliceActions.setIsIndividualProfileDrawerOpen({ isOpen: false }));
	};

	return (
		<>
			<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
				<Button onClick={closeIndividualProfileModal} variant="text" className={buttonClassName}>
					<IconRenderer icon="arrowLeft" size={16} viewbox="0 0 16 16" color={colors['dark-grey']} /> {gobackbuttonText}
				</Button>
				<IconRenderer
					boxProps={{ onClick: closeIndividualProfileModal, style: { cursor: 'pointer' } }}
					icon="closeIcon"
					size={16}
					viewbox="0 0 512 512"
					color={colors['dark-grey']}
				/>
			</div>
			{data && <HydratedTwigHtmlString html={data} />}
		</>
	);
};

export default memo(PartnerProfileModalContent);
